export default __webpack_public_path__ + "static/media/phplogo.7c34ef39.jpg";